import { USER_TYPE } from '../../../../utils/authorization'

export const COLOR_SCHEME = {
  active: {
    background: '#EDF5FE',
    border: '#2C73E8',
    titleBackground: '#2C73E8',
    title: '#FFFFFF',
  },
  deactive: {
    background: '#FFFFFF',
    border: '#D5D5D5',
    titleBackground: '#EDF5FE',
    title: '#191D25',
  },
  standard: {
    subscriptionBackground: '#717ECD',
    text: '#FFFFFF',
  },
  premium: {
    subscriptionBackground: '#FFCD60',
    text: '#191D25',
  },
}

export const DETAIL_PLANS_TITLE = [
  {
    title: 'userManagement.viewDetailPlans.FEATURE',
    key: 'name',
    thColor: '#C8E3FF',
    isI18n: true,
  },
  { title: 'BASIC', key: 'basic', thColor: '#ADD5FF' },
  { title: 'LITE', key: 'lite', thColor: '#94C8FF' },
  { title: 'STANDARD', key: 'standard', thColor: '#7ABBFF' },
  { title: 'PREMIUM', key: 'premium', thColor: '#61AFFF' },
]

export const PACKAGE_LIST_TITLE = [
  {
    title: 'userManagement.packageList.SERVICE',
    key: 'name',
    thColor: '#C8E3FF',
    isI18n: true,
  },
  {
    title: 'Basic',
    key: 'Basic',
    userTypeId: USER_TYPE.BASIC,
    thColor: '#ADD5FF',
  },
  {
    title: 'Lite',
    key: 'Lite',
    userTypeId: USER_TYPE.LITE,
    thColor: '#94C8FF',
  },
  {
    title: 'Standard',
    key: 'Standard',
    userTypeId: USER_TYPE.STANDARD,
    thColor: '#7ABBFF',
  },
  {
    title: 'Premium',
    key: 'Premium',
    userTypeId: USER_TYPE.PREMIUM,
    thColor: '#61AFFF',
  },
]

export const PACKAGE_HEIGHT = {
  Small: { vi: 82, en: 82 },
  Medium: { vi: 84, en: 84 },
  Large: { vi: 102, en: 85 },
}

export const CUSTOM = 'Custom'
export const USER_TYPE_STANDARD = 'Standard'

export const CUSTOM_PLAN = {
  id: 6,
  code: CUSTOM,
  benefits: [
    {
      id: 1,
      benefit: 'userManagement.upgradeViewPlan.benefitCustomPlan.FIRST',
    },
    {
      id: 2,
      benefit: 'userManagement.upgradeViewPlan.benefitCustomPlan.SECOND',
    },
    {
      id: 3,
      benefit: 'userManagement.upgradeViewPlan.benefitCustomPlan.THIRD',
    },
    {
      id: 4,
      benefit: 'userManagement.upgradeViewPlan.benefitCustomPlan.FOURTH',
    },
  ],
}

export const SUB_TITLE = {
  [USER_TYPE.BASIC]: 'userManagement.upgradeViewPlan.SUB_TITLE_BASIC',
  [USER_TYPE.LITE]: 'userManagement.upgradeViewPlan.SUB_TITLE_LITE',
  [USER_TYPE.PREMIUM]: 'userManagement.upgradeViewPlan.SUB_TITLE_PREMIUM',
  [USER_TYPE.STANDARD]: 'userManagement.upgradeViewPlan.SUB_TITLE_PREMIUM',
  [CUSTOM_PLAN.id]: 'userManagement.upgradeViewPlan.SUB_TITLE_CUSTOM',
}
